import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {Modal} from 'react-bootstrap';
import axios from '../../../interceptor/axios-config';
import { useStudentsData } from '../../../context/StudentsContext';
import { IMAGES } from '../Dashboard/Content';
import { Link } from 'react-router-dom';
import { useGrade } from '../../../context/GradeContext';
import Swal from 'sweetalert2';
import config from '../../../config';


const EditStudentDetail = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);

    const { studentsData, refreshData } = useStudentsData();
    const [editedFormData, setEditedFormData] = useState([]);
    // const [editedDetail, setEditedDetail] = useState(null);
    const { grade } = useGrade(); 
    const [file, setFile] = useState(null)

    // type file for image 
    // const [imgFile, setImgFile] = useState(null)

    useImperativeHandle(ref, () => ({
        openModal(student_id) {               
            let idtoEdit = [];
            if(studentsData.length >0){
                idtoEdit = studentsData.filter(id => id.student_id === student_id);
            }
            // setEditedDetail(idtoEdit[0]);
            setEditedFormData({
                student_id:student_id,
                full_name:idtoEdit[0].full_name,
                pass_photo:idtoEdit[0].pass_photo,
                pen:idtoEdit[0].pen,
                sex:idtoEdit[0].sex,
                dob:idtoEdit[0].dob,
                place_of_birth:idtoEdit[0].place_of_birth,
                class_admitted:idtoEdit[0].class_admitted,
                roll_no:idtoEdit[0].roll_no,
                email:idtoEdit[0].email,
                aadhar_no:idtoEdit[0].aadhar_no,
                guardian_name:idtoEdit[0].guardian_name,
                contact_no:idtoEdit[0].contact_no,
                r_address: idtoEdit[0].r_address
            });
            setModalBox(true)  ;        
        },  
    }));

    const handleChange = (e) => {
        const { name, value, type } = e.target;   

        if (type === 'file') {
        // Convert the selected file to Base64
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setEditedFormData({ ...editedFormData, [name]: reader.result });
        };
        if (file) {
            reader.readAsDataURL(file);
        }
        } else {
            setEditedFormData({ ...editedFormData, [name]: value });
        }
    };
    
       
    const fileHandler = (e) => {       
        setFile(e.target.files[0]);	

        const { name, value, type } = e.target;   

        if (type === 'file') {
        // Convert the selected file to Base64
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setEditedFormData({ ...editedFormData, [name]: reader.result });
        };
        if (file) {
            reader.readAsDataURL(file);
        }
        } else {
            setEditedFormData({ ...editedFormData, [name]: value });
        }	
    }

    const RemoveFile = () =>{
        setFile(null)
    }

    const closeEditDetail = ()=>{
        RemoveFile();
        setModalBox(false);
    }

    const submitChanges = async (event) => {
        try {
          event.stopPropagation();
         console.log(editedFormData);
          // First POST request
          const firstResponse = await axios.patch(
            `${config.apiBaseUrl}/students/update/updateDetail.php`,
            editedFormData
          );

          console.log('Update request successful:', firstResponse.data);
          // Handle the response of the second request here
          setEditedFormData({
            student_id: '',
            full_name: '',
            dob: '',
            pass_photo: null,
            class_admitted: '',
            sex: '',
            email: '',
            roll_no: '',
            admission_status: '',
            guardian_name: '',
            aadhar_no: '',
            r_address: '',
          });
          RemoveFile();
      
          // You can add further actions after the second successful request here      
          Swal.fire({
            icon: 'success',
            title: 'Update successfull',
            text: 'Student detail updated successfully!',
          });

          refreshData();
          setModalBox(false);

        } catch (error) {
          console.error('POST request error:', error);
          // Handle errors for both requests here
        }
      };

    return (
        <div>
        <Modal  onHide={setModalBox} size="xl" show={modalBox} centered>
        <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Student Detail Update Form</h5>
                    <button type="button" className="btn-close"  onClick={closeEditDetail}></button>
                </div>
                <div className="modal-body">
                    <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-3 col-lg-4 d-block">
                                            <div>
                                                <label className="form-label text-primary">Photo<span className="required">*</span></label>
                                                <div className="avatar-upload">
                                                    <div className="avatar-preview">
                                                        <div id="imagePreview"                                                 
                                                            // style={{backgroundImage: file ? "url(" + URL.createObjectURL(file) + ")" : "url(" + IMAGES.noimage +")" }}
                                                            style={{
                                                                backgroundImage: file
                                                                    ? `url(${URL.createObjectURL(file)})`
                                                                    : editedFormData?.pass_photo
                                                                    ? `url(${editedFormData.pass_photo})`
                                                                    : `url(${IMAGES.noimage})`
                                                                }}
                                                            > 			
                                                        </div>                                                        
                                                    </div>                                                    
                                                    <div className="change-btn mt-2 mb-lg-0 mb-3">
                                                        <input type='file' className="form-control d-none" name="pass_photo" onChange={fileHandler}  id="imageUpload" accept=".png, .jpg, .jpeg" />
                                                        <label htmlFor="imageUpload" className="dlab-upload mb-0 btn btn-primary btn-sm">Choose File</label>
                                                        <Link to={"#"} className="btn btn-danger light remove-img ms-2 btn-sm" onClick={RemoveFile}>Remove</Link>
                                                    </div>
                                                </div>	
                                            </div>
                                            <span className='p-4'></span>
                                            <div className="flex flex-wrap mx-3 mb-1">
                                                <div className="file-input w-full px-9 mb-1 md:mb-0">
                                                    <label className="form-label text-primary" htmlFor="grid-first-name">
                                                        Gender
                                                    </label>
                                                    <div className='flex'>
                                                        <label className="flex form-label text-primary p-2">
                                                        <input
                                                            className='p-4'
                                                            type="checkbox"
                                                            name="sex"
                                                            value="male"
                                                            checked={editedFormData.sex === 'male'}
                                                            onChange={handleChange}
                                                        />
                                                        <span className='p-2'>Male</span>
                                                        </label>
                                                        <span className="p-2"></span>
                                                        <label className="flex form-label text-primary p-2">
                                                        <input
                                                            className='p-4'
                                                            type="checkbox"
                                                            name="sex"
                                                            value="female"
                                                            checked={editedFormData.sex === 'female'}
                                                            onChange={handleChange}
                                                        />
                                                        <span className='p-2'>Female</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <span className='p-4'></span>
                                            <div className="flex flex-wrap mx-3 mb-1">
                                                
                                            </div>
                                        </div>
                                        <div className="col-xl-9 col-lg-8">
                                            <div className="row">
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput1" className="form-label text-primary">Full Name<span className="required">*</span></label>
                                                        <input                                                     
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput1"                                                     
                                                            name="full_name"
                                                            value={editedFormData.full_name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label  className="form-label text-primary">Date & Place of Birth<span className="required">*</span></label>
                                                        <div className="d-flex">                                                    
                                                            <input                                                     
                                                                type="date" 
                                                                className="form-control" 
                                                                id="exampleFormControlInput7"                                                     
                                                                name="dob"
                                                                value={editedFormData.dob}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                            <input                                                     
                                                                type="text" 
                                                                className="form-control w-50 ms-3" 
                                                                id="exampleFormControlInput7"                                                     
                                                                name="place_of_birth"
                                                                value={editedFormData.place_of_birth}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput3" className="form-label text-primary">Email<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="email" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput3" 
                                                            name="email"
                                                            value={editedFormData.email}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlTextarea1" className="form-label text-primary">Address<span className="required">*</span></label>
                                                        <textarea                                                    
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlTextarea1" 
                                                            rows="5"
                                                            name="r_address"
                                                            value={editedFormData.r_address}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput4" className="form-label text-primary">Class<span className="required">*</span></label>
                                                        {/* <input type="text" className="form-control" id="exampleFormControlInput4" placeholder="Wally" /> */}
                                                        <select name="class_admitted" value={editedFormData.class_admitted} onChange={handleChange} className="form-control" id="exampleFormControlInput4" required>
                                                            <option value="">--Class--</option>
                                                            {grade.map((item) => <option value={item.class_options}>{item.class_label}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Guardian Name<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput5" 
                                                            name="guardian_name"
                                                            value={editedFormData.guardian_name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput6" className="form-label text-primary">Phone Number<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="number" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput6" 
                                                            name="contact_no"
                                                            value={editedFormData.contact_no}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput6" className="form-label text-primary">Aadhar Number<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="number" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput6" 
                                                            name="aadhar_no"
                                                            value={editedFormData.aadhar_no}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput1" className="form-label text-primary">Permanent Education Number (PEN) <span className="required">*</span></label>
                                                        <input                                                     
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput1"                                                     
                                                            name="pen"
                                                            value={editedFormData.pen}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success light" onClick={submitChanges}>Save</button>
                        <button type="button" className="btn btn-danger light" onClick={closeEditDetail}>Close</button>
                    </div>
                </div>                
            </Modal>
        </div>
    )
});

export default EditStudentDetail;
